import { hexToHsl } from 'common/utils/color-utils'

interface SemanticColorGroup {
  primaryColor: string
  colors: Array<{
    cssVar: string
    hueDelta?: number
    lightness?: number
    saturation?: number
    lightnessMultiplier?: number
  }>
}

export const semanticColorGroups: SemanticColorGroup[] = [
  {
    primaryColor: '--color-brandPrimary',
    colors: [
      { cssVar: '--color-brandPrimary' },
      { cssVar: '--color-brandPrimaryHover', lightnessMultiplier: 0.9 },
      { cssVar: '--color-brandPrimaryPressed', lightnessMultiplier: 0.8 },

      { cssVar: '--color-brandSecondary', lightness: 95 },
      { cssVar: '--color-brandSecondaryHover', lightness: 90 },
      { cssVar: '--color-brandSecondaryPressed', lightness: 85 },
    ],
  },
  {
    primaryColor: '--color-brandTextPrimary',
    colors: [
      { cssVar: '--color-brandTextPrimary' },
      { cssVar: '--color-brandTextSecondary', lightness: 60 },
    ],
  },
  {
    primaryColor: '--color-brandPrimary',
    colors: [
      { cssVar: '--color-brandTextLink' },
      { cssVar: '--color-brandTextLinkHover', lightnessMultiplier: 0.9 },
      { cssVar: '--color-brandTextLinkPressed', lightnessMultiplier: 0.8 },
    ],
  },
] as const

export const adjustColorGroup = (
  baseColorHex: string,
  group: SemanticColorGroup,
): Record<string, string> => {
  const updatedColors: Record<string, string> = {}

  group.colors.forEach(colorDef => {
    if (colorDef.cssVar === group.primaryColor) {
      // Основной цвет
      updatedColors[colorDef.cssVar] = hexToHsl({ hex: baseColorHex })
    } else {
      const baseHsl = hexToHsl({ hex: baseColorHex, valuesOnly: true })
      const [hBase, sBase, lBase] = baseHsl
        .replace('%', '')
        .split(',')
        .map(v => parseFloat(v))

      let newHue = hBase + (colorDef.hueDelta ?? 0)
      if (newHue < 0) newHue += 360
      if (newHue >= 360) newHue -= 360

      const newSaturation = colorDef.saturation ?? sBase
      const newLightness =
        colorDef.lightness ??
        (colorDef.lightnessMultiplier
          ? lBase * colorDef.lightnessMultiplier
          : lBase)

      updatedColors[colorDef.cssVar] =
        `hsl(${Math.round(newHue)},${Math.round(newSaturation)}%,${Math.round(newLightness)}%)`
    }
  })

  return updatedColors
}
